const addStepNumbersToTitles = (t, theme, doc = document) => {
  const steps = doc.querySelectorAll(
    '.c-print-content__step--with-formatted-title'
  )

  for (let step of steps) {
    let titleElement = step.querySelector('h2')

    if (titleElement === null) {
      return
    }

    let titleText = titleElement.innerHTML
    titleElement.parentElement.removeChild(titleElement)

    let title = doc.createElement('h2')

    title.classList.add('c-print-content__title-wrapper')
    title.classList.add(`c-print-content__title-wrapper--${theme}`)

    title.innerHTML = stepNumberHTML(t, titleText, step.dataset.stepNumber)

    step.insertBefore(title, step.firstChild)
  }
}

const displayAllHints = (doc = document) => {
  doc
    .querySelectorAll('.c-project-panel--hints > .c-project-panel__content')
    .forEach((el) => {
      el.className = el.className.replace('u-hidden', '')
    })
}

const displayAllIngredients = (doc = document) => {
  doc
    .querySelectorAll(
      '.c-project-panel--ingredient > .c-project-panel__content'
    )
    .forEach((el) => {
      el.className = el.className.replace('u-hidden', '')
    })
}

const resizeScratchblocks = (doc = document) => {
  const RESIZE_FACTOR = 0.66
  doc
    .querySelectorAll('.language-blocks3 > .scratchblocks > svg')
    .forEach((el) => {
      const elWidth = el.getAttribute('width')
      const elHeight = el.getAttribute('height')
      el.setAttribute('viewBox', `0 0 ${elWidth} ${elHeight}`)
      el.setAttribute('width', elWidth * RESIZE_FACTOR)
      el.setAttribute('height', elHeight * RESIZE_FACTOR)
    })
}

const stepNumberHTML = (t, title, stepNumber) => {
  return [
    `<span class="c-print-content__step-number">${t(
      'printout.step'
    )} ${stepNumber}</span>`,
    `<span class="c-print-content__title">${title}</span>`,
  ].join('')
}

export {
  addStepNumbersToTitles,
  displayAllHints,
  displayAllIngredients,
  resizeScratchblocks,
  stepNumberHTML,
}
